/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateExamTypeDto
 */
export interface CreateUpdateExamTypeDto {
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamTypeDto
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamTypeDto
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamTypeDto
     */
    importantNote?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamTypeDto
     */
    popular?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamTypeDto
     */
    price?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamTypeDto
     */
    batteryId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamTypeDto
     */
    categoryId?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamTypeDto
     */
    online?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamTypeDto
     */
    onlinePayment?: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof CreateUpdateExamTypeDto
     */
    selectHarmfulFactors?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateExamTypeDto
     */
    customFieldsId?: string | null;
}

/**
 * Check if a given object implements the CreateUpdateExamTypeDto interface.
 */
export function instanceOfCreateUpdateExamTypeDto(value: object): value is CreateUpdateExamTypeDto {
    return true;
}

export function CreateUpdateExamTypeDtoFromJSON(json: any): CreateUpdateExamTypeDto {
    return CreateUpdateExamTypeDtoFromJSONTyped(json, false);
}

export function CreateUpdateExamTypeDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateExamTypeDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'importantNote': json['importantNote'] == null ? undefined : json['importantNote'],
        'popular': json['popular'] == null ? undefined : json['popular'],
        'price': json['price'] == null ? undefined : json['price'],
        'batteryId': json['batteryId'] == null ? undefined : json['batteryId'],
        'categoryId': json['categoryId'] == null ? undefined : json['categoryId'],
        'online': json['online'] == null ? undefined : json['online'],
        'onlinePayment': json['onlinePayment'] == null ? undefined : json['onlinePayment'],
        'selectHarmfulFactors': json['selectHarmfulFactors'] == null ? undefined : json['selectHarmfulFactors'],
        'customFieldsId': json['customFieldsId'] == null ? undefined : json['customFieldsId'],
    };
}

export function CreateUpdateExamTypeDtoToJSON(value?: CreateUpdateExamTypeDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'description': value['description'],
        'importantNote': value['importantNote'],
        'popular': value['popular'],
        'price': value['price'],
        'batteryId': value['batteryId'],
        'categoryId': value['categoryId'],
        'online': value['online'],
        'onlinePayment': value['onlinePayment'],
        'selectHarmfulFactors': value['selectHarmfulFactors'],
        'customFieldsId': value['customFieldsId'],
    };
}

